import { useState } from "react";
import { useKeenSlider } from "keen-slider/react";
import { PhotoProps } from "../photo";
import { gallery } from "./gallery.variants";

export type UseGalleryProps = {
  className?: string;
  type?: "photo" | "floor";
  title?: string;
  data: PhotoProps["data"][];
};

export const useGallery = (props: UseGalleryProps) => {
  const { className = "", type = "photo", title, data = [] } = props;

  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1,
  });

  const styles = gallery();

  const openLightboxImage = (index: number) => {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: index,
    });
  };

  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
    initial: 0,
    slides: {
      spacing: 12,
      perView: 2,
    },
    breakpoints: {
      "(min-width: 0px)": {
        slides: { perView: 1, spacing: 12 },
      },
      "(min-width: 640px)": {
        slides: { perView: 2, spacing: 12 },
      },
    },
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    },
  });

  return {
    styles,
    className,
    sliderRef,
    instanceRef,
    loaded,
    currentSlide,
    lightboxController,
    openLightboxImage,
    type,
    title,
    data,
  };
};
